package navigation.home.edititinerary

import androidx.compose.runtime.*
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.core.screen.ScreenKey
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryEvent
import com.essntl.features.itinerary.ui.edit_itinerary.EditItineraryNavigation
import com.essntl.features.itinerary.ui.edit_itinerary.components.ItineraryServicesList
import navigation.home.edititineraryservice.EditItineraryServiceScreenNav

class ItineraryServicesListScreen(
    private val itineraryId: String,
) : Screen {

    override val key: ScreenKey = "ItineraryServicesListScreen-$itineraryId"

    @Composable
    override fun Content() {
        val editItineraryScreenModel = koinScreenModel<EditItineraryScreenModel>()
        val editItineraryState by editItineraryScreenModel.state.collectAsState()

        val navigator = LocalNavigator.currentOrThrow

        LaunchedEffect(itineraryId) {
            editItineraryScreenModel.onEvent(EditItineraryEvent.ClearItineraryState)
            editItineraryScreenModel.onEvent(EditItineraryEvent.GetItinerary(itineraryId))
        }

        ItineraryServicesList(
            state = editItineraryState,
            onEvent = editItineraryScreenModel::onEvent,
            confirmed = false,
            onNavigation = { event ->
                if (event is EditItineraryNavigation.EditItineraryService) {
                    navigator.push(
                        EditItineraryServiceScreenNav(
                            event.itineraryService.id,
                            event.itineraryService.itineraryId,
                        ),
                    )
                }
            },
        )
    }
}
